import { useEffect } from 'react';
import { init } from '@fullstory/browser';
import { User } from '__generated__/graphql/legacy/graphql';
import { isSiteAdmin } from 'utils/userHelpers';

interface FullstoryScriptProps {
  fullstory?: {
    orgId: string;
    enabled: boolean;
    studentTrackingEnabled: boolean;
  };
  user?: User;
}

const useFullstory = ({ fullstory, user }: FullstoryScriptProps) => {
  useEffect(() => {
    if (!fullstory || !fullstory.orgId || !fullstory.enabled) return;
    if (!user?.roles || !isSiteAdmin(user?.roles)) return;
    init({ orgId: fullstory.orgId });
  }, [fullstory]);
};

export default useFullstory;
